import { baseApiRoutes } from '../../core/config/apiRoutes';

export const apiRoutes = {
  ...baseApiRoutes,
  employees: {
    get: 'employees/:id',
    getSchedule: 'employees/:id/schedule',
    list: 'employees',
    employee: 'employees/employee',
    listAvailability: 'employees/availability',
    create: 'employees',
    update: 'employees/:id',
    updateSchedule: 'employees/:id/schedule',
    archive: 'employees/:id/archive',
    setPassword: 'employees/:id/set-password',
    delete: 'employees/:id',
    rolesOptions: 'employees/role-options',
    typesOptions: 'employees/type-options',
    options: 'employees/options',
    bulkDelete: 'employees/bulk-delete',
  },
  employeeSettings: {
    get: 'employee-settings/:id',
    update: 'employee-settings/:id',
  },
  settings: {
    get: 'settings',
    getSchedule: 'settings/schedule',
    getDayWorkTime: 'settings/work-time/:date/day',
    getWeekWorkTime: 'settings/work-time/:date/week',
    getMonthWorkTime: 'settings/work-time/:date/month',
    update: 'settings',
    updateSchedule: 'settings/schedule',
  },
  vehicles: {
    get: 'vehicles/:id',
    list: 'vehicles',
    create: 'vehicles',
    update: 'vehicles/:id',
    delete: 'vehicles/:id',
    options: 'vehicles/options',
  },
  clients: {
    get: 'clients/:id',
    list: 'clients',
    create: 'clients',
    update: 'clients/:id',
    delete: 'clients/:id',
    options: 'clients/options',
    optionsActive: 'clients/options/active',
    archive: 'clients/:id/archive',
    updateContacts: 'clients/:id/contacts',
  },
  clientVehicles: {
    get: 'client-vehicles/:id',
    getCommentsCount: 'client-vehicles/:id/total-comments',
    getGallery: 'client-vehicles/:id/gallery',
    list: 'client-vehicles',
    create: 'client-vehicles',
    update: 'client-vehicles/:id',
    delete: 'client-vehicles/:id',
    options: 'client-vehicles/options',
    optionsByClient: 'client-vehicles/:client/options',
  },
  timeOffs: {
    get: 'time-offs/:id',
    getSchedule: 'time-offs/schedule',
    getPendingCount: 'time-offs/pending-count',
    list: 'time-offs',
    employeeList: 'time-offs/employee',
    create: 'time-offs',
    createSelf: 'time-offs/employee',
    update: 'time-offs/:id',
    updateSelf: 'time-offs/employee/:id',
    approve: 'time-offs/:id/approve',
    reject: 'time-offs/:id/reject',
    delete: 'time-offs/:id',
    deleteSelf: 'time-offs/employee/:id',
    typesOptions: 'time-offs/type-options',
    statusOptions: 'time-offs/status-options',
  },
  items: {
    get: 'items/:id',
    list: 'items',
    listItems: 'items/items',
    listServices: 'items/services',
    create: 'items',
    update: 'items/:id',
    delete: 'items/:id',
    options: 'items/options',
    getCalculatedPrice: 'items/calculated-price',
    vehicleSizeOptions: 'items/options/vehicle-size',
    quantityTypeOptions: 'items/options/quantity-type',
    itemCategoryOptions: 'items/options/item-category',
    itemOptions: 'items/options/item',
    serviceOptions: 'items/options/service',
    availableServiceOptions: 'items/options/available-services',
    packageOptions: 'items/options/package',
    duplicate: 'items/:id/duplicate',
  },
  orders: {
    get: 'orders/:id',
    list: 'orders',
    listGetCommercialOffers: 'orders/commercial-offers',
    getKanban: 'orders/kanban',
    priorityOptions: 'orders/options/priority',
    create: 'orders',
    uploadCommercialOfferImage: 'orders/upload-image',
    createWash: 'orders/wash',
    sendCommercialOffer: 'orders/commercial-offers/:id/send',
    confirmCommercialOffer: 'orders/commercial-offers/:id/confirm',
    confirmCommercialOfferOptional:
      'orders/commercial-offers/:id/confirm-optional',
    confirmCommercialOfferPublic:
      'orders/commercial-offers/confirm-public/:token',
    cancelCommercialOffer: 'orders/commercial-offers/:id/cancel',
    update: 'orders/:id',
    updatePriority: 'orders/:id/update-priority',
    updateStatus: 'orders/:id/update-status',
    cancelOrder: 'orders/:id/cancel',
    delete: 'orders/:id',
    bulkDelete: 'orders/bulk-delete',
  },
  orderSchedules: {
    intervalTypeOptions: 'order-schedules/options/interval-type',
  },
  invoices: {
    get: 'invoices/:id',
    getOrdersInvoicePreview: 'invoices/preview-orders-invoice',
    getInvoicePreview: 'invoices/:id/preview',
    checkPaymentStatus: 'invoices/:id/check-payment-status',
    getStatusOptions: 'invoices/options/status',
    list: 'invoices',
    createFromOrder: 'invoices/order/:orderId',
    createFromOrders: 'invoices/order/bulk',
    createSummaryItem: 'invoices/:id/summary-item',
    deleteSummaryItem: 'invoices/:id/delete-summary-item',
    update: 'invoices/:id',
    updateStatus: 'invoices/:id/status',
    sendInvoice: 'invoices/:id/send',
    initializeCardPayment: 'invoices/:id/initialize-card-payment',
    completeCashPayment: 'invoices/:id/cash-payment',
    completeBankPayment: 'invoices/:id/bank-payment',
    delete: 'invoices/:id',
    getTaxPercentage: 'invoices/:id/tax-percentage',
    getReverseTaxPercentage: 'invoices/:id/reverse-tax-percentage',
  },
  invoiceCollections: {
    generate: 'invoice-collections/generate',
    download: 'invoice-collections/:id/download',
  },
  tasks: {
    get: 'tasks/:id',
    schedule: 'tasks/schedule',
    employeeSchedule: 'tasks/employee-schedule',
    scheduleColumns: 'tasks/schedule/columns',
    scheduleColumnEmployees: 'tasks/schedule/column/employees',
    scheduleWeeklyColumnEmployees: 'tasks/schedule/column-weekly/employees',
    updateTime: 'tasks/:id/update-time',
    updateStatus: 'tasks/:id/update-status',
    unplanTask: 'tasks/:id/unplan-task',
    unplanAllTasks: 'tasks/:id/unplan-all-tasks',
    deleteTask: 'tasks/:id/delete-task',
    deleteAllTasks: 'tasks/:id/delete-all-tasks',
    getMainCategoryOptions: 'tasks/options/main-category',
    getStatusOptions: 'tasks/options/status',
  },
  subTasks: {
    list: 'sub-tasks',
    getByTask: 'sub-tasks/by-task/:id',
    startWork: 'sub-tasks/:id/start-work',
    stopWork: 'sub-tasks/:id/stop-work',
    continueWork: 'sub-tasks/:id/continue-work',
    completeWork: 'sub-tasks/:id/complete-work',
  },
  clientVehicleComments: {
    create: 'client-vehicle-comments',
  },
  employeeTransfers: {
    get: 'employee-transfers/:id',
    list: 'employee-transfers',
    create: 'employee-transfers',
    update: 'employee-transfers/:id',
    delete: 'employee-transfers/:id',
  },
  subTaskAggregatedWorkLogs: {
    list: 'sub-task-aggregated-work-logs',
    listWithStatistics: 'sub-task-aggregated-work-logs/with-statistics',
    listWithStatisticsForEmployee:
      'sub-task-aggregated-work-logs/with-statistics/employee',
    get: 'sub-task-aggregated-work-logs/:id',
    create: 'sub-task-aggregated-work-logs',
    update: 'sub-task-aggregated-work-logs/:id',
    delete: 'sub-task-aggregated-work-logs/:id',
  },
  invoiceItems: {
    list: 'invoice-items',
  },
  timeBlocks: {
    get: 'time-blocks/:id',
    create: 'time-blocks',
    update: 'time-blocks/:id',
    delete: 'time-blocks/:id',
  },
  timeBlockSchedules: {
    intervalTypeOptions: 'time-block-schedules/options/interval-type',
  },
  employeeCheckIn: {
    isCurrentlyActive: 'employee-check-in/status',
    checkIn: 'employee-check-in/check-in',
    checkOut: 'employee-check-in/check-out',
  },
  ipWhitelist: {
    get: 'ip-whitelist/:id',
    list: 'ip-whitelist',
    create: 'ip-whitelist',
    update: 'ip-whitelist/:id',
    delete: 'ip-whitelist/:id',
  },
  expenses: {
    get: 'expenses/:id',
    list: 'expenses',
    create: 'expenses',
    update: 'expenses/:id',
    delete: 'expenses/:id',
  },
};
